// Vendor imports
const qs = require('qs')
// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const commonClient = require('client-v2/common/client')
// Entry imports
const configureStore = require('./state/store')
const rootFactory = require('./components/root').factory
const { showArticleProfileModal } = require('./containers/feed/actions')

const routerActionToStreamType = {
  'search.showDomainPosts': 'SEARCH_POSTS',
  'search.showQueryCollections': 'SEARCH_MIXES',
  'search.showQueryInterests': 'SEARCH_INTERESTS',
  'search.showQueryPeople': 'SEARCH_PEOPLE',
  'search.showQueryPosts': 'SEARCH_POSTS'
}

commonClient.runAfterPageIsLoaded(() => {

  const { store } = commonClient.render(configureStore, rootFactory)

  const { router, query, user } = store.getState()
  const streamType = routerActionToStreamType[router.action]

  commonClient.configureSession(store, {
    pageName: 'SEARCH_PAGE',
    streamKey: query.decoded,
    streamType
  })

  businessEvents.trackProtobuf('TrackStreamProfileView', {
    userId: user.id,
    streamType
  })
  businessEvents.trackSegment('pageview')

  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true })
  if (streamType === 'SEARCH_POSTS' && queryParams.modal) {
    store.dispatch(showArticleProfileModal())
  }

})
